import BurgerMenu from './burger-menu';

export default BurgerMenu;
